'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("OffreLTEditionPopinController", function ($scope, $http, $q, contrepartieService, lovService, indexationService) {
  var isEdit = $scope.edit;
  $scope.searchExtraParams = {
    retireComptesSatellites: true
  };
  $scope.searchConfig = {
    stickToValue: "offre.compteNomInterne",
    labelAttribute: "nomInterne",
    searchUrl: "/rest/intra/comptes/search",
    extraParams: "searchExtraParams",
    resultTemplate: '<span class="name" ng-bind-html="result.nomInterne | underlineSearchResultMatch:search.q"></span>',
    onSelect: function onSelect(compte) {
      if (compte == null) {
        $scope.offre.compteId = null;
      } else {
        $scope.offre.compteId = compte.id;
      }
    }
  };
  $scope.typesModaliteIndexation = [{
    id: "FIXE",
    label: 'Fixe'
  }, {
    id: "VARIABLE",
    label: 'Variable'
  }];
  $scope.typesModaliteIndexationCNU = [{
    id: "FIXE",
    label: 'Fixe'
  }, {
    id: "VARIABLE",
    label: 'Variable'
  }, {
    id: "AUTRE",
    label: 'Autre'
  }];
  $q.when(contrepartieService.getContreparties()).then(function (contreparties) {
    $scope.contreparties = contreparties;
  });
  $q.when(indexationService.getIndicesClient()).then(function (indices) {
    $scope.indices = indices;
  });
  var initTauxMinMax = function initTauxMinMax() {
    // tauxMax
    $scope.tauxMax = {
      checked: false,
      value: null
    };
    $scope.$watch("offre.indexation.tauxMax", function (tauxMax) {
      $scope.tauxMax = {
        checked: tauxMax != null,
        value: $scope.tauxMax.value || tauxMax
      };
    });
    $scope.$watch("tauxMax", function (tauxMax) {
      if (tauxMax.checked) {
        $scope.offre.indexation.tauxMax = tauxMax.value;
      } else {
        $scope.offre.indexation.tauxMax = null;
      }
    }, true);

    // tauxMin
    $scope.tauxMin = {
      checked: false,
      value: null
    };
    $scope.$watch("offre.indexation.tauxMin", function (tauxMin) {
      $scope.tauxMin = {
        checked: tauxMin != null,
        value: $scope.tauxMin.value || tauxMin
      };
    });
    $scope.$watch("tauxMin", function (tauxMin) {
      if (tauxMin.checked) {
        $scope.offre.indexation.tauxMin = tauxMin.value;
      } else {
        $scope.offre.indexation.tauxMin = null;
      }
    }, true);
  };
  if ($scope.newOffre) {
    $scope.offre = $scope.newOffre;
  } else
    // modification d'une offre existante
    if ($scope.offreId) {
      $http.get("/rest/intra/offres/saisie/LT/" + $scope.offreId).then(function (response) {
        $scope.offre = response.data;
        initTauxMinMax();
      });
    } else {
      // nouvelle offre à partir d'une copie
      if ($scope.copieId) {
        $http.get("/rest/intra/offres/saisie/LT/" + $scope.copieId).then(function (response) {
          $scope.offre = response.data;
          $scope.offre.id = null;
          initTauxMinMax();
        });
      } else {
        $scope.offre = {
          indexation: {},
          indexationCNU: {},
          visibleClient: true
        };
        initTauxMinMax();
      }
    }
  $scope.offreFormConfig = {
    url: function url() {
      return '/rest/intra/offres/saisie/LT/save';
    },
    data: function data() {
      return $scope.offre;
    },
    customValidation: function customValidation() {
      var errors = [];
      if ($scope.offre && $scope.offre.dateOffre == null) {
        errors.push({
          fieldName: 'dateOffre',
          message: 'La date est obligatoire.'
        });
      }
      return errors;
    },
    fieldPrefix: "offre.",
    fields: {
      banqueId: {
        mandatory: true
      }
    },
    onSuccess: function onSuccess(offre) {
      $scope.$close(offre);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/journalOffres/edition/offreLTEditionPopin.js
// module id = 2832
// module chunks = 13